import { $t } from '@previo/core'
import { Codebook } from '../Codebook'

export enum PackageUnitTypeId {
  PER_PIECE = 1,
  PER_NIGHT = 2,
  PER_PERSON_NIGHT = 3,
  PER_PERSON = 4,
  PER_ROOM_NIGHT = 5,
  PER_ROOM = 6,
  PER_HOUR = 7,
  PER_MINUTE = 8,
  PER_PERSON_HOUR = 9,
  PER_PERSON_MINUTE = 10,
  PER_PACKAGE = 11,
  PER_MEAL = 12,
  PER_SERVICE = 13,
  PER_DAY = 14,
  PER_OCCASION = 15,
  PER_KG = 16,
}

export class PackageUnitType extends Codebook<PackageUnitTypeId> {
  static readonly PER_PIECE = new PackageUnitType(
    PackageUnitTypeId.PER_PIECE,
    () => $t('/pcs'),
    () => $t('The price is one-off per piece.'),
    false,
    false,
    false,
  )

  static readonly PER_NIGHT = new PackageUnitType(
    PackageUnitTypeId.PER_NIGHT,
    () => $t('/night'),
    () => $t('Price is per each night.'),
    true,
    false,
    false,
  )

  static readonly PER_PERSON_NIGHT = new PackageUnitType(
    PackageUnitTypeId.PER_PERSON_NIGHT,
    () => $t('/pers./night'),
    () => $t('Price is per each person and night.'),
    true,
    true,
    false,
  )

  static readonly PER_PERSON = new PackageUnitType(
    PackageUnitTypeId.PER_PERSON,
    () => $t('/pers.'),
    () => $t('Price is per each person.'),
    false,
    true,
    false,
  )

  static readonly PER_ROOM_NIGHT = new PackageUnitType(
    PackageUnitTypeId.PER_ROOM_NIGHT,
    () => $t('/room/night'),
    () => $t('Price is per each room and night.'),
    true,
    false,
    true,
  )

  static readonly PER_ROOM = new PackageUnitType(
    PackageUnitTypeId.PER_ROOM,
    () => $t('/room'),
    () => $t('Price is per each room.'),
    false,
    false,
    true,
  )

  static readonly PER_HOUR = new PackageUnitType(
    PackageUnitTypeId.PER_HOUR,
    () => $t('/hour'),
    () => $t('Price is per each hour'),
    false,
    false,
    false,
  )

  static readonly PER_MINUTE = new PackageUnitType(
    PackageUnitTypeId.PER_MINUTE,
    () => $t('/min.'),
    () => $t('Price is per each minute'),
    false,
    false,
    false,
  )

  static readonly PER_PERSON_HOUR = new PackageUnitType(
    PackageUnitTypeId.PER_PERSON_HOUR,
    () => $t('/pers./hour'),
    () => $t('Price is per each hour and person'),
    false,
    true,
    false,
  )

  static readonly PER_PERSON_MINUTE = new PackageUnitType(
    PackageUnitTypeId.PER_PERSON_MINUTE,
    () => $t('/pers./min.'),
    () => $t('Price is per each minute and person'),
    false,
    true,
    false,
  )

  static readonly PER_PACKAGE = new PackageUnitType(
    PackageUnitTypeId.PER_PACKAGE,
    () => $t('/stay package'),
    () => $t('Price is one-time per the entire stay package'),
    false,
    false,
    false,
  )

  static readonly PER_MEAL = new PackageUnitType(
    PackageUnitTypeId.PER_MEAL,
    () => $t('/meal'),
    () => $t('Price is calculated per each meal'),
    false,
    false,
    false,
  )

  static readonly PER_SERVICE = new PackageUnitType(
    PackageUnitTypeId.PER_SERVICE,
    () => $t('/service'),
    () => $t('Price is one-time per service'),
    false,
    false,
    false,
  )

  static readonly PER_DAY = new PackageUnitType(
    PackageUnitTypeId.PER_DAY,
    () => $t('/day'),
    () => $t('Price is calculated per each day'),
    false,
    false,
    false,
  )

  static readonly PER_OCCASION = new PackageUnitType(
    PackageUnitTypeId.PER_OCCASION,
    () => $t('/occasion'),
    () => $t('Price is calculated per occasion'),
    false,
    false,
    false,
  )

  static readonly PER_KG = new PackageUnitType(
    PackageUnitTypeId.PER_KG,
    () => $t('/kg'),
    () => $t('Price is calculated per kilogram'),
    false,
    false,
    false,
  )

  private constructor(
    id: PackageUnitTypeId,
    public name: () => string,
    public description: () => string,
    public readonly perNight: boolean,
    public readonly perPerson: boolean,
    public readonly perRoom: boolean,
  ) {
    super(id)
  }
}
